// utils/authChannel.js
const AUTH_BC_NAME = "lodos_auth_channel";

// -- Yeni: kısa süreli yönlendirme blokajı anahtarları
const SUPPRESS_KEY = "AUTH_SUPPRESS_REDIRECT_UNTIL";
const DEFAULT_SUPPRESS_TTL_MS = 8000; // 8 sn: istersen arttır

// -- Yeni: blokaj başlat
export function setRedirectSuppress(ttlMs = DEFAULT_SUPPRESS_TTL_MS) {
  try {
    const until = Date.now() + Math.max(0, ttlMs | 0);
    sessionStorage.setItem(SUPPRESS_KEY, String(until));
  } catch {}
}

// -- Yeni: blokaj aktif mi?
export function isRedirectSuppressed() {
  try {
    const raw = sessionStorage.getItem(SUPPRESS_KEY);
    const until = raw ? parseInt(raw, 10) : 0;
    return Number.isFinite(until) && Date.now() < until;
  } catch {
    return false;
  }
}

/**
 * Geriye dönük uyumlu: ikinci argümandaki opsiyonları mesaja merge eder.
 * Örn: broadcastAuthMessage({type:'LOGIN', ...}, { suppressRedirect:true, onlyOthers:true })
 */
export function broadcastAuthMessage(message, options = {}) {
  try {
    const payload = { ...message, ...options };

    // suppressRedirect isteniyorsa bu sekmede de hemen blokajı başlat
    if (payload?.suppressRedirect) {
      setRedirectSuppress(); // aynı tabda anında devreye girer
    }

    if ("BroadcastChannel" in window) {
      const bc = new BroadcastChannel(AUTH_BC_NAME);
      bc.postMessage(payload);
      bc.close();
    }

    // storage olayı diğer sekmelerde tetiklenecek (aynı sekmede tetiklenmez)
    localStorage.setItem(
      "auth_sync",
      JSON.stringify({ ...payload, ts: Date.now() })
    );
  } catch (e) {
    console.error("Broadcast error:", e);
  }
}

export function subscribeAuthMessage(callback) {
  let bc;
  if ("BroadcastChannel" in window) {
    bc = new BroadcastChannel(AUTH_BC_NAME);
    bc.onmessage = (ev) => {
      const msg = ev.data;
      // suppressRedirect geldiyse bu sekmede de blokaj kur
      if (msg?.suppressRedirect) setRedirectSuppress();
      callback(msg);
    };
  }

  const onStorage = (ev) => {
    if (ev.key === "auth_sync" && ev.newValue) {
      try {
        const msg = JSON.parse(ev.newValue);
        // suppressRedirect geldiyse bu sekmede de blokaj kur
        if (msg?.suppressRedirect) setRedirectSuppress();
        callback(msg);
      } catch {}
    }
  };
  window.addEventListener("storage", onStorage);

  return () => {
    if (bc) bc.close();
    window.removeEventListener("storage", onStorage);
  };
}